import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { merge } from 'lodash';

export enum TMEventType
{
    jsPageError = 'gtm.pageError',
    searchServices = 'search_services'
}

export interface TMEventJSError
{
    errorMessage: string;
}

export interface TMEventSearchServices
{
    organization: string;
    serviceCategory?: string;
    searchOrganization?: string;
    submittingOrganization?: string;
    cityServed?: string;
    countyServed?: string;
    zipServed?: string;
    language?: string;
    targetedPopulation?: string;
    targetedDemographic?: string;
}

@Injectable({
    providedIn: 'root'
})
export class TagManagerEventService
{
    public enabled = false;
    private window: any;

    constructor(@Inject(DOCUMENT) private document: Document)
    {
        this.window = this.document.defaultView;
        setTimeout(() =>
        {
            this.enabled = this.window.google_tag_manager !== undefined;
        }, 250);
    }

    public sendTagManagerEvent(eventType: TMEventType,
        eventData: TMEventJSError | TMEventSearchServices): void
    {
        if (this.enabled)
        {
            const sendData = merge({ event: eventType }, eventData);
            this.window.dataLayer.push(sendData);
        }
    }
}
